export type OnConnectFunction = () => void;
export type OnCloseFunction = () => void;
export type MessageHandlerFunction = (error: string, message: WebSocketMessage) => void;
export type OnMessageFunction = (...args: any[]) => void;
export type OnErrorFunction = (...args: any[]) => void;

export interface WebSocketMessage {
  type: string;
  address: string;
  body: any;
}

export interface SubscriptionMessage {
  type: 'subscribe' | 'unsubscribe';
  data?: any
  topic?: SubscriptionTopic;
}

export enum SubscriptionTopic {
  SYMBOL_POSITION = 'SYMBOL_POSITION',
  ORDER = 'ORDER',
  TRADE = 'TRADE',
  BADGE_NOTIFICATION = 'BADGE_NOTIFICATION',
  MARKET_DATA = 'MARKET_DATA'
}

export interface WebSocketResponse {
  type: MessageType;
  data: any;
}

export enum MessageType {
  SYMBOL_POSITION = 'SYMBOL_POSITION',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  ORDER_UPDATE = 'ORDER_UPDATE',
  TRADE_UPDATE = 'TRADE_UPDATE',
  PING = 'PING',
  BADGE_NOTIFICATION = 'BADGE_NOTIFICATION',
  MARKET_DATA = 'MARKET_DATA'
}